<template>
    <div class="card-producto shadow-sm h-100">
        <!-- Imagen principal -->
        <div class="card-producto-img-container">
            <img :src="item.PicturesUrl[item.categorias?.[0]?.marcas?.viewimagesprinc ?? 4]?.sm || '/img/display/Placeholder.webp'"
                :alt="item.k_parte" class="card-producto-img" />
        </div>

        <!-- Badges -->
        <div class="mb-2 card-producto-badges-placeholder">
            <Badges v-if="
                (item.especial && item.especial !== 'False' && item.especial !== 'false') ||
                item.badgenuevo ||
                item.mejoresventaslineas ||
                item.mejoresventas
            " :item="item" wrapperClass="d-flex flex-wrap gap-2 justify-content-center" :fontSize="'13px'" />
        </div>

        <!-- Información -->
        <div class="card-producto-info text-center">
            <!-- Línea -->
            <p class="card-producto-category" v-if="item.linea">{{ item.linea }}</p>

            <!-- Nombre o clave -->
            <h5 class="card-producto-name card-producto-link"
                @click="$router.push({ name: 'detalleProducto', query: { claveprod: item.k_parte } })"
                style="cursor: pointer;">
                {{ item.k_parte }}
            </h5>

            <!-- Descripción / aplicación -->
            <p class="card-producto-description">
                <span v-if="item.aplicaciones && item.aplicaciones.length > 0">
                    {{ item.aplicaciones[0].marca }} -
                    {{ item.aplicaciones[0].modelo }} ({{ item.aplicaciones[0].year }})
                    <span v-if="item.aplicaciones[0].posicion && item.aplicaciones[0].posicion !== '-'">
                        <strong>{{ item.aplicaciones[0].posicion }}</strong>
                    </span>
                </span>
            </p>

            <!-- Botón hover -->
            <div class="card-producto-hover-actions">
                <button class="btn btn-success-custom w-100"
                    @click="$router.push({ name: 'detalleProducto', query: { claveprod: item.k_parte } })">
                    Ver Detalles
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
export default {
    name: 'CardsProducto',
    components: {
        Badges: defineAsyncComponent(() => import('../../ComponentsRecomend/Sliders/Badges.vue')),
    },
    props: {
        item: { type: Object, required: true },
    },
}
</script>

<style scoped>
/* ===========================
   ESTRUCTURA GENERAL DE CARD
   =========================== */
.card-producto {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #f8f8f8;
    background: #f8f8f8;
    color: #06283c;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 420px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-producto:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* ===========================
   IMAGEN PRINCIPAL
   =========================== */
.card-producto-img-container {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f8f8;
    overflow: hidden;
}

.card-producto-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

/* ===========================
   INFORMACIÓN
   =========================== */
.card-producto-info {
    background: #fff;
    color: #06283c;
    padding: 15px;
    border-top: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
}

/* ===========================
   RESERVAMOS ESPACIO FIJO
   =========================== */
.card-producto-badges-placeholder {
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Línea */
.card-producto-category {
    color: #262626;
    font-size: 0.8rem;
    text-transform: uppercase;
    opacity: 0.8;
    margin: 0 0 6px 0;
    min-height: 16px;
}

/* Nombre/clave */
.card-producto-name {
    font-weight: 600;
    margin: 0 0 6px 0;
    line-height: 1.2;
    min-height: 2.4em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* Aplicaciones / descripción */
.card-producto-description {
    font-size: 0.9rem;
    opacity: 0.85;
    margin: 0 0 6px 0;
    min-height: 48px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* ===========================
   BOTÓN / HOVER
   =========================== */
.card-producto-hover-actions {
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    opacity: 0;
    transform: translateY(6px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: none;
}

.card-producto:hover .card-producto-hover-actions {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
}



/* Hover en móvil */
@media (max-width: 992px) {
    .card-producto-hover-actions {
        opacity: 1;
        transform: none;
        pointer-events: auto;
    }
}

/* ===========================
   DETALLES ADICIONALES
   =========================== */
.card-producto-link:hover {
    color: #ff9900!important;
}

</style>